import {defineStore} from 'pinia';

export const useProductStore = defineStore('productStore', {
    state: () => ({
        product: null,
        breadcrumbs: null
    }),
    actions: {

    }
});
